import { HC_ORG_ID } from '@hcs/authn';
import { Account } from '@hcs/types';

export const checkIsAccountInternal = (
  account: Account | undefined,
): boolean => {
  return account?.organization.id === HC_ORG_ID;
};
